import contract, {selectors} from '@mailobj-browser/front/js/contracts/contract.js'
import array from '@mailobj-browser/front/js/utils/array.js'
import redirect from '#utilities/js/hotkey/redirect.js'
import dynamicRedirect from './dynamicRedirect/dynamicRedirect.js'
import selectAll from './selectAll/selectAll.js'
import translateForm from './translateForm/translateForm.js'

export default contract({
    [selectors]: {
        'slot[data-name="hotkey-back"]': array([
            dynamicRedirect
        ]),
        'slot[data-name="hotkey-help"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-all"]': array([
            selectAll
        ]),
        'slot[data-name="hotkey-search"]': array([
            dynamicRedirect
        ]),
        'slot[data-name="hotkey-translate"]': array([
            translateForm
        ]),
        'slot[data-name="hotkey-applications"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-dashboard"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-mail"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-docs"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-calendar"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-adbook"]': array([
            redirect
        ]),
        'slot[data-name="hotkey-list"]': array([
            redirect
        ]),
    }
})